import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import { convertStraight } from "../common-data/Converts";
import { CheckCircleIcon } from "../../images/icons/icons";

const GymFeedbackListings = ({
  userInfoData,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
  callFunction,
}) => {
  const { gymFeedbacksLoading, gymFeedbacks } = useSelector(
    (state) => state.hygiene
  );

  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);

  useEffect(() => {
    if (
      !gymFeedbacksLoading &&
      gymFeedbacks?.status &&
      gymFeedbacks?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: gymFeedbacks.data,
        pagination:
          gymFeedbacks?.pagination?.length > 0 ? gymFeedbacks.pagination : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [gymFeedbacksLoading, gymFeedbacks]);

  const tbColumns = [
    {
      dataField: "gym_name",
      text: "gym  name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150" style={{ textAlign: "start" }}>
            {row?.gym_name || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "name",
      text: "user info",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.name || "NA"}
            <br />
            <small className="lowercase underline">{row?.mobile || ""}</small>
            <br />
            <small className="badge bg-danger">
              {row?.account_type?.replace(/_/g, " ") || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "rating",
      text: "rating",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth60">{row?.rating || "-"} ✰</span>
        );
      },
    },
    {
      dataField: "feedback",
      text: "feedback",
      formatter: (_, row) => {
        return (
          <>
            {row?.feedback?.length <= 30 ? (
              <span className="tb-data minWidth60">
                {row?.feedback || "NA"}
              </span>
            ) : (
              <span
                className="tb-data minWidth60"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardName: "feedback",
                    rowData: row,
                  }))
                }
              >
                {row?.feedback?.substring(0, 30)} <b>...Read More</b>
              </span>
            )}
          </>
        );
      },
    },
    {
      dataField: "category",
      text: "feedback for",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.category?.replace(/_/g, " ") || ""}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Feedback Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? convertStraight(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "resolve_status",
      text: "Reslove Status",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.resolve_status ? (
              <CheckCircleIcon />
            ) : (
              <button
                className="actionBtn"
                style={{
                  opacity: "1",
                  cursor: "pointer",
                  background: "#2973B2",
                  color: "#fff",
                  borderRadius: "8px",
                  fontSize: "15px",
                  padding: "10px",
                  textTransform: "capitalize",
                }}
                onClick={() =>
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardName: "resolve-form",
                    rowData: row,
                  }))
                }
              >
                resolve issue
              </button>
            )}
          </span>
        );
      },
    },
  ];

  return (
    <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
      {gymFeedbacksLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <PaymentLinkTable
          tableData={allDatas.allData}
          tableColumns={tbColumns}
          tablePagination={allDatas.pagination}
          isPage={isPage}
          setIsPage={(value) => setIsPage(value)}
          isFirstColSticky={true}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      )}
    </div>
  );
};

export default GymFeedbackListings;
